import React, { useState } from "react";
import { useSettings } from "context/Settings.context";
import Button from "components/Common/Button/Button";
import Modal from "components/Common/Modal/Modal";
import TextField from "../../../components/Common/TextField/TextField";
import {
    ZoomFetchFileType,
    ZOOM_FETCH_FILE_TYPE_LABELS,
} from "./MorningMeetingDetails.types";
import FetchZoomFileModalContainer from "./FetchZoomFileModal.styles";

interface Props {
    fileType: ZoomFetchFileType;
    onClose: () => void;
    onConfirm: (zoomMeetingId: string) => void;
}

const FetchZoomFileModal = ({ fileType, onClose, onConfirm }: Props) => {
    const { setToast } = useSettings();
    const [zoomMeetingId, setZoomMeetingId] = useState("");

    const label = ZOOM_FETCH_FILE_TYPE_LABELS[fileType];
    const title = `Fetch Meeting ${label}`;

    const isFormValid = (): boolean => {
        if (!zoomMeetingId || zoomMeetingId.trim() === "") {
            setToast({
                show: true,
                type: "error",
                message: "Please enter a valid zoom meeting id",
            });
            return false;
        }
        return true;
    };

    const handleConfirm = () => {
        if (isFormValid()) {
            const id = zoomMeetingId.trim().replace(/\s/g, "");
            onConfirm(id);
        }
    };

    return (
        <FetchZoomFileModalContainer>
            <Modal onClose={onClose}>
                <div className="main">
                    <div className="text">
                        <h3>{title}</h3>
                    </div>
                    <TextField
                        label="Zoom Meeting ID"
                        placeholder="Enter zoom meeting id"
                        change={(val: string) => setZoomMeetingId(val)}
                        value={zoomMeetingId}
                        type="text"
                    />
                </div>
                <div className="actions">
                    <Button text="CANCEL" color="flat" click={onClose} />
                    <Button text="CONFIRM" click={handleConfirm} />
                </div>
            </Modal>
        </FetchZoomFileModalContainer>
    );
};

export default FetchZoomFileModal;
